import { SimpleGrid } from '@chakra-ui/react'

import { CircleMediaForm } from '@/components/molecules/Form/Circles/MediaForm/CircleMediaForm'

export const MediaStep = () => {
  return (
    // Logo and cover side by side (each Field is a direct grid child).
    <SimpleGrid columns={{ base: 1, sm: 2 }} gap={6} w="full">
      <CircleMediaForm />
    </SimpleGrid>
  )
}
